import TournamentComponent from "./TournamentComponent";
import TitleComponent from "./TitleComponent";

function MedagliereDetail({ medals, titles }) {
  return (
    <div className="divide-y divide-gray-200">
      {titles != null && titles.length > 0 && (
        <TitleComponent titles={titles} />
      )}
      {medals.map((tournament, index) => (
        <TournamentComponent
          key={index}
          tournamentName={tournament.tournament}
          tournamentDate="15/06/2026"
          medals={tournament.medals}
        />
      ))}
    </div>
  );
}

export default MedagliereDetail;
